import React from 'react';
import useStyles from '../styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Form from 'components/form';
import useSnack from 'hooks/useSnack';
import { useMutation } from '@apollo/react-hooks';
import { UPDATE_STUDENT_PROFILE } from 'graphql/student/Profile';
import CheckboxGroup from 'components/form/CheckboxGroup';
import Divider from '@material-ui/core/Divider';
import Button from 'components/common/Button';
import extend from 'lodash/extend';
import ACTIVITIES from 'constant/activities';
import Input from 'components/form/Input';
import { Box } from '@material-ui/core';

const FormItem = Form.FormItem;

const AcademicInterest = ({
  highschool_info,
  user,
  form: { getFieldDecorator, validateFields },
  editable,
}) => {
  const classes = useStyles();
  const snack = useSnack();
  const [update] = useMutation(UPDATE_STUDENT_PROFILE);

  const onSubmit = () => {
    return validateFields().then((values) => {
      return update({
        variables: {
          id: user.id,
          input: {
            highschool_info: extend(highschool_info, values),
          },
        },
      }).then(
        () => {
          window.analytics.track('Profile: Extracurricular updated', {
            highschool_info: extend(highschool_info, values),
          });
          snack.success('Profile saved');
        },
        (e) => {
          snack.error(e.message);
        },
      );
    });
  };

  return (
    <Card className={classes.card}>
      <CardContent className={classes.cardContent}>
        <Grid container spacing={4}>
          <Grid item md={12}>
            <Typography align="center" gutterBottom variant="h5">
              Extracurricular Activities
            </Typography>
            <Typography component="p" align="center" variant="caption">
              Tell us which types of activities you have been involved in during
              high school
            </Typography>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              className={classes.activityFormContainer}
            >
              <Form className={classes.formRoot}>
                <FormItem>
                  {getFieldDecorator('extra_activities', {
                    initialValue: highschool_info?.extra_activities,
                  })(
                    <CheckboxGroup
                      disabled={!editable}
                      size="small"
                      options={ACTIVITIES}
                    />,
                  )}
                </FormItem>
                <FormItem>
                  {getFieldDecorator('extra_activities_description', {
                    initialValue: highschool_info?.extra_activities_description,
                  })(
                    <Input
                      disabled={!editable}
                      fullWidth
                      label="Describe your extracurricular activities in detail."
                      placeholder="Extracurricular activities"
                    />,
                  )}
                </FormItem>
              </Form>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardContent className={classes.footer}>
        <Button
          size="large"
          variant="contained"
          color="primary"
          onClick={onSubmit}
          disabled={!editable}
        >
          Save
        </Button>
      </CardContent>
    </Card>
  );
};

export default Form.create()(AcademicInterest);
